import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'filterDailyPositions',
  pure: true
})

export class FilterDailyPositionsPipe implements PipeTransform {
  
  transform(items: any[], onlyDaily: boolean): any {
    if(onlyDaily){
      return items.filter(item => item.executedBuy !== '0' || item.executedSell !== '0');
    }
    return items;
  }
}
